<template>
  <div class="custom-fixed-button-main-container position-fixed">
    <Transition name="bounce">
      <div v-if="showButtons">
        <button
          @click.stop="$emit('onCreate')"
          class="d-flex border-0 custom-rounded p-3 mb-2 bg-help justify-content-center align-items-center"
        >
          <div class="d-flex flex-1 justify-content-center text-white">
            Create my own reward
          </div>
        </button>
        <button
          @click.stop="$emit('onSeeIdeas')"
          class="d-flex border-0 custom-rounded p-3 mb-2 bg-help justify-content-center align-items-center"
          v-if="!optionMe"
        >
          <span class="d-flex flex-1 justify-content-center text-white">
            See reward ideas
          </span>
        </button>
      </div>
    </Transition>
    <button
      @click="handleOnClick"
      :style="`background-color:${backgroundColor};`"
      class="d-flex border-0 justify-content-between align-items-center custom-rounded p-0"
    >
      <div
        :style="`background-color:${iconColor};color:${backgroundColor};`"
        class="fixed-button-icon custom-rounded d-flex justify-content-center align-items-center"
      >
        <span class="material-icons align-middle">
          card_giftcard
        </span>
      </div>
      <div class="d-flex flex-1 justify-content-center pr-4 text-white">
        + New reward
      </div>
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    backgroundColor: {
      type: String,
      default: '#D79B95',
    },
    iconColor: {
      type: String,
      default: '#EACCC9',
    },
    optionMe:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showButtons: false,
    };
  },
  computed: {
    ...mapGetters('user', ['userIsAParent']),
  },
  methods: {
    handleOnClick() {
      this.showButtons = !this.showButtons;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-fixed-button-main-container {
  bottom: 2rem;
  right: 2rem;
  z-index: 20;

  @media (min-width: 570px) {
    bottom: 1rem;
  }
  .custom-rounded {
    border-radius: 1.687rem;
  }
  button {
    width: 14.25rem;
    height: 3.375rem;
    outline: none;
    box-shadow: 3px 3px 6px #00000029;

    .flex-1 {
      flex: 1;
    }

    .fixed-button-icon {
      width: 3.375rem;
      height: 3.375rem;
      top: calc(50% - 1.688rem);
      box-shadow: 0px 3px 6px #00000029;
      * {
        font-size: 30px;
      }
    }
    @media (max-width: 601px) {
      width: 14.25rem;
      height: 2.375rem;

      .fixed-button-icon {
        width: 2.375rem;
        height: 2.375rem;
        top: 0;
      }
    }
  }
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-out 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bounce-out {
  0% {
    transform: translateY(100px) scale(0);
  }
  50% {
    transform: translateY(0.5px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
